import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
// @ts-expect-error cannot find  typed file
import VidyardVideoPlayer from 'ui-addon-video-player/components/VidyardVideoPlayer';
export const getVideoPlayerComponent = videoType => videoType === 'HUBSPOT_VIDEO' ? HubSpotVideoPlayer : VidyardVideoPlayer;